import * as aphrodite from 'aphrodite/no-important'
import aphroditeInterfaceFactory from 'react-with-styles-interface-aphrodite/lib/aphroditeInterfaceFactory'

const globalSelectorHandler = (selector, _, generateSubtreeStyles) => {
  if (selector[0] !== '*') {
    return null
  }

  return generateSubtreeStyles(selector.slice(1))
}

const globalExtension = { selectorHandler: globalSelectorHandler }

const myAphrodite = aphrodite.StyleSheet.extend([globalExtension])

export default aphroditeInterfaceFactory(myAphrodite)



// WEBPACK FOOTER //
// ./styles/aphroditeInterfaceGlobal.js